const VidePlayIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={72}
    height={72}
    viewBox="0 0 72 72"
    fill="none"
    {...props}
  >
    <path
      d="M36 0C55.8823 0 72 16.1177 72 36C72 55.8823 55.8823 72 36 72C16.1177 72 0 55.8823 0 36C0 16.1177 16.1177 0 36 0ZM30.375 22.7949C28.875 21.9566 27 23.0049 27 24.6816V47.3184C27 48.9952 28.875 50.0434 30.375 49.2051L50.625 37.8867C52.125 37.0483 52.125 34.9517 50.625 34.1133L30.375 22.7949Z"
      fill="white"
      fillOpacity={0.6}
    />
  </svg>
);
export default VidePlayIcon;
